const emailExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneExp = /^\d{3}-\d{3,4}-\d{4}$/;
const phoneExp2 = /^\d{2,3}-\d{3,4}-\d{4}$/;

export const isEmail = email => {
  return emailExp.test(email);
};

export const isPhone = phone => {
  return phoneExp.test(phone) || phoneExp2.test(phone);
};
